export default {
  validMachine: {
    error: {
      nameInUse: {
        en: "Name in use, change the name.",
        pt: "Nome em uso, mude o nome.",
      },
      emptyName: {
        en: "Empty name. Previous name used.",
        pt: "Nome vazio. Nome anterior utilizado.",
      },
      multiplesInitialStates: {
        en: "Multiple initial states",
        pt: "Múltiplos estados iniciais",
      },
      missInitialState: {
        en: "Miss initial state",
        pt: "Falta de estado inicial",
      },
      missFinalStates: {
        en: "Miss final state",
        pt: "Falta de estado final",
      },
      missState: {
        en: "Miss states",
        pt: "Falta de estado",
      },
      afterMessage: {
        en: "Return the draw area and check the automaton",
        pt: "Retorne à area de desenho e corrija o autômato",
      },
      missAutomatonType: {
        en: "Select an automaton type to enable the drawing",
        pt: "Selecione um tipo de autômato para habilitar o desenho",
      },
    },

    success: {
      valid: {
        en: "Success",
        pt: "Sucesso",
      },
    },
  },
  invalidFormat: {
    en: "Invalid format, please check the file",
    pt: "Formato inválido, por favor verifique o arquivo",
  },

  validState: {
    error: {
      nameInUse: {
        en: "Name in use, change the name.",
        pt: "Nome em uso, mude o nome.",
      },
      emptyName: {
        en: "Empty name. Previous name used.",
        pt: "Nome vazio. Nome anterior utilizado.",
      },
    },
  },
};
